module.exports = __webpack_public_path__ + "static/media/24.11125999.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shirts/24.png
// module id = 1463
// module chunks = 0